/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/entrypoint-root-module-path */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { ObjectListFlyoutEntryPointRuntimeProps } from '@atlassian/navigation-common/types';
import parameters from './__generated__/useRecentItemsQuery.graphql.ts';

type EntryPointParams = { cloudId: string; count: number };

type RecentFlyoutEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	Record<string, never>,
	// Disabled because the entrypoint component imported from platform
	// eslint-disable-next-line @atlassian/react-entrypoint/entrypoint-component-props-from-entrypoint-types
	ObjectListFlyoutEntryPointRuntimeProps,
	Record<string, never>
>;

export const recentFlyoutEntrypoint: EntryPoint<RecentFlyoutEntryPointComponent, EntryPointParams> =
	createEntryPoint({
		root: JSResourceForInteraction<RecentFlyoutEntryPointComponent>(
			/* webpackChunkName: "async-object-list-flyout-entrypoint" */ '@atlassian/global-side-navigation/flyout-menu-item-content',
			{ moduleId: 'objectListFlyoutEntrypoint' },
		),
		getPreloadProps: ({ cloudId, count }: EntryPointParams) => ({
			queries: {
				recentMenuData: {
					parameters,
					options: { fetchPolicy: 'store-and-network' as const },
					variables: { cloudId, count, keyword: '' },
				},
			},
		}),
	});
